/* Slide helpers scoped to the announcement bar (height animation for elements toggled from display: none) */
const announcementSlideUp = (target, time) => {
  const duration = time ? time : 400;
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const announcementSlideDown = (target, time) => {
  const duration = time ? time : 400;
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

if (!customElements.get('announcement-bar')) {
  customElements.define(
    'announcement-bar',
    class AnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-announcement-toggle]').forEach((toggle) => {
          toggle.addEventListener('click', (event) => {
            event.preventDefault();
            const panel = this.querySelector('#' + toggle.dataset.announcementToggle);
            if (!panel) return;
            if (panel.classList.contains('open')) {
              this.closePanel(panel);
            } else {
              this.querySelectorAll('.announcement-bar__panel.open').forEach((other) => this.closePanel(other));
              panel.classList.add('open');
              toggle.classList.add('show-dropdown');
              toggle.setAttribute('aria-expanded', 'true');
              announcementSlideDown(panel);
              this.refreshHeaderMeasurements();
            }
          });
        });

        this.querySelectorAll('[data-panel-close]').forEach((button) => {
          button.addEventListener('click', () => {
            const panel = button.closest('.announcement-bar__panel');
            if (panel) this.closePanel(panel);
          });
        });

        this.querySelectorAll('[data-timer-close]').forEach((button) => {
          button.addEventListener('click', () => {
            const bar = button.closest('.announcement-bar__timer-bar');
            if (bar) bar.remove();
            this.refreshHeaderMeasurements();
          });
        });
      }

      closePanel(panel) {
        panel.classList.remove('open');
        const toggle = this.querySelector(`[data-announcement-toggle="${panel.id}"]`);
        if (toggle) {
          toggle.classList.remove('show-dropdown');
          toggle.setAttribute('aria-expanded', 'false');
        }
        announcementSlideUp(panel);
        this.refreshHeaderMeasurements();
      }

      /* Keep --header-height and sticky trigger offsets in sync with the bar's
         current height (see refreshHeaderOffsets in theme.js). Waits for the
         slide animation to finish before measuring. */
      refreshHeaderMeasurements() {
        window.setTimeout(() => {
          if (typeof window.refreshHeaderOffsets === 'function') window.refreshHeaderOffsets();
        }, 420);
      }
    }
  );
}
